export default __webpack_public_path__ + "static/media/no_tasks_for_you_icon.32d9b62c.svg";